import React from 'react';

const TermsPage = () => {
  return (

    <div
      className="relative min-h-screen text-white font-sans"
      dir="rtl"
      style={{ direction: 'rtl', textAlign: 'right' }}
    >

      {                                }
      <div className="absolute inset-0 w-full h-full pointer-events-none">
        <img
          src="/images/stars.png"
          alt="Background Stars"
          className="w-full h-full object-cover opacity-80"
        />
      </div>

      {             }
      {                                                                    }
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">

        {            }
        <header className="mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#28e3da40] bg-[#081423]/30 px-4 py-1 mb-4">
            <span className="inline-block w-2 h-2 rounded-full bg-[#28E3DA]" />
            <span className="text-xs sm:text-sm text-[#E4F1FF]">
              وثيقة تنظيمية
            </span>
          </div>

          <h1 className="text-3xl md:text-4xl font-semibold text-[#F5F6FF] mb-4">
            سياسة الاستخدام
          </h1>

          <p className="text-sm sm:text-base md:text-lg leading-loose text-[#CBD5F5] max-w-3xl">
            استخدامك لمنصّة همّة يعني موافقتك على سياسة الاستخدام هذه وسياسة الخصوصية. الهدف من
            السياسة هو تنظيم طريقة النشر والتفاعل داخل المنصّة وحماية المستخدمين من الإساءة،
            بدون تعقيد قانوني أو مصطلحات مبالغ فيها.
          </p>
        </header>

        {                         }
        <section className="mb-10 md:mb-12">
          <h2 className="text-2xl font-semibold text-[#F5F6FF] mb-4">
            أولًا: المقدمة والتعريفات
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {             }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                1.1 مقدمة
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose">
                همّة منصّة طلابية مستقلة تتيح للطلاب مشاركة تجاربهم وتقييماتهم للمقررات
                وأعضاء هيئة التدريس مع الحفاظ على خصوصيتهم. استخدامك للمنصّة يعني أنك قرأت
                هذه السياسة ووافقت على ما ورد فيها.
              </p>
            </div>

            {               }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                1.2 تعريفات أساسية
              </h3>
              <ul className="text-sm sm:text-base text-[#CBD5F5] leading-loose space-y-1 list-disc pr-4">
                <li><span className="font-semibold text-[#F5F6FF]">المنصّة / نحن:</span> موقع همّة.</li>
                <li><span className="font-semibold text-[#F5F6FF]">المستخدم / أنت:</span> أي شخص يتصفح أو ينشر أو يستخدم خدمات همّة.</li>
                <li><span className="font-semibold text-[#F5F6FF]">التقييم:</span> أي رأي أو تعليق أو تجربة يتم نشرها داخل المنصّة.</li>
              </ul>
            </div>
          </div>
        </section>

        {                              }
        <section className="mb-10 md:mb-12">
          <h2 className="text-2xl font-semibold text-[#F5F6FF] mb-4">
            ثانيًا: إرشادات المحتوى
          </h2>

          {             }
          <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6 mb-6">
            <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose">
              الهدف من التقييمات هو مساعدة الطلاب على تكوين صورة أوضح عن المقررات وأساليب
              التدريس. عشان كذا نحتاج يكون المحتوى صادق، محترم، ومركّز على التجربة التعليمية
              نفسها.
            </p>
          </div>

          {                                }
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {             }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                2.1 ما يُسمح به
              </h3>
              <ul className="text-sm sm:text-base text-[#CBD5F5] leading-loose space-y-1 list-disc pr-4">
                <li>مشاركة تجربة شخصية حقيقية مع المادة أو الدكتور.</li>
                <li>ذكر الإيجابيات والسلبيات بأسلوب هادئ وواضح.</li>
                <li>التركيز على طريقة الشرح، الاختبارات، التعامل، وضوح السلايدات... إلخ.</li>
                <li>كتابة التقييم بالعربية أو بالإنجليزية فقط.</li>
              </ul>
            </div>

            {             }
            <div className="rounded-2xl border border-[#FA8686]/40 bg-[#2A0C12]/60 p-6 border-dashed">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                2.2 ما يُمنع نشره
              </h3>
              <ul className="text-sm sm:text-base text-[#FCA5A5] leading-loose space-y-1 list-disc pr-4">
                <li>السب، الشتم، الإهانة، أو أي ألفاظ مسيئة.</li>
                <li>السخرية من الشكل، العمر، الجنس، العِرق، أو الانتماء الديني.</li>
                <li>ذكر معلومات شخصية يمكن من خلالها الوصول للدكتور أو الطالب.</li>
                <li>نشر إشاعات أو اتهامات بدون دليل (مثل اتهامات بالعنصرية أو الفساد... إلخ).</li>
                <li>الحديث عن الحياة الشخصية أو العائلية للدكتور.</li>
                <li>الإعلانات، الروابط الترويجية، أو المحتوى غير المرتبط بالدراسة.</li>
                <li>تكرار تقييم نفس الدكتور لنفس المادة بعدّة حسابات.</li>
              </ul>
              <p className="mt-3 text-xs sm:text-sm text-[#FECACA]">
                تحتفظ همّة بحق حذف أي تقييم يخالف ما سبق، أو لا يضيف محتوى جوهريًا مفيدًا، أو
                يبدو أنه مكتوب بنية استفزاز أو تشويه.
              </p>
            </div>
          </div>
        </section>

        {                                      }
        <section className="mb-10 md:mb-12">
          <h2 className="text-2xl font-semibold text-[#F5F6FF] mb-4">
            ثالثًا: حدود المسؤولية والخصوصية
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {               }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                3.1 حدود المسؤولية
              </h3>
              <ul className="text-sm sm:text-base text-[#CBD5F5] leading-loose space-y-1 list-disc pr-4">
                <li>منصّة همّة لا تمثّل أي جهة رسمية أو أكاديمية.</li>
                <li>كل تقييم يمثّل رأي صاحبه فقط، وليس رأي المنصّة.</li>
                <li>القرارات الأكاديمية التي يتخذها الطالب مسؤول عنها هو، وليست مسؤولية المنصّة.</li>
                <li>لا نضمن دقة أو اكتمال كل ما يُنشر من قِبل المستخدمين.</li>
              </ul>
            </div>

            {              }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                3.2 الخصوصية باختصار
              </h3>
              <ul className="text-sm sm:text-base text-[#CBD5F5] leading-loose space-y-1 list-disc pr-4">
                <li>لا تظهر هوية المستخدم للآخرين عند نشر التقييم.</li>
                <li>لا نطلب بيانات شخصية حساسة لا حاجة لها في الخدمة.</li>
                <li>يتم جمع بعض البيانات التقنية (مثل نوع الجهاز والصفحات التي تزورها) لتحسين الخدمة فقط.</li>
                <li>لا يتم مشاركة البيانات مع جهات خارجية إلا للامتثال لنظام أو طلب رسمي ملزم.</li>
              </ul>

            </div>
          </div>
        </section>

        {                                                            }
        <section className="mb-10 md:mb-12">
          <h2 className="text-2xl font-semibold text-[#F5F6FF] mb-4">
            رابعًا: استخدام المنصّة والتعديلات
          </h2>

          <div className="space-y-6">
            {                      }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                4.1 استخدام المنصّة
              </h3>
              <ul className="text-sm sm:text-base text-[#CBD5F5] leading-loose space-y-1 list-disc pr-4">
                <li>تتعهد بعدم محاولة اختراق الموقع أو تعطيل عمله.</li>
                <li>تتعهد بعدم إنشاء حسابات متعددة بهدف التأثير على التقييمات.</li>
                <li>تتعهد بعدم استخدام المنصّة للدعاية التجارية أو نشر السبام.</li>
              </ul>
            </div>

            {               }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                4.2 التعديلات على السياسة
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose">
                قد نقوم بتحديث هذه السياسة من وقت لآخر. استمرارك في استخدام المنصّة بعد نشر أي
                تحديث يُعتبر موافقة ضمنية على النسخة المحدّثة، لذلك يُفضّل مراجعة الصفحة كل فترة.
              </p>
            </div>

            {                     }
            <div className="rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <h3 className="text-lg font-semibold text-[#F5F6FF] mb-2">
                4.3 إيقاف أو إنهاء الاستخدام
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose mb-2">
                يحق لإدارة همّة إيقاف أو تعطيل أي حساب في الحالات التالية:
              </p>
              <ul className="text-sm sm:text-base text-[#CBD5F5] leading-loose space-y-1 list-disc pr-4">
                <li>تكرار مخالفة سياسة المحتوى.</li>
                <li>إساءة استخدام المنصّة أو إزعاج الآخرين.</li>
                <li>استخدام أساليب احتيالية للتأثير على التقييمات أو إخفاء الهوية لأغراض ضارّة.</li>
              </ul>
            </div>
          </div>
        </section>

    {                                        }
        <section
          className="border border-[#28e3da40] bg-[#081423]/60 rounded-2xl p-6"
          dir="rtl"
          style={{ direction: 'rtl', textAlign: 'right' }}
        >
          <h2 className="text-xl md:text-2xl font-semibold text-[#F5F6FF] mb-3">
            خامسًا: القانون وخلاصة السياسة
          </h2>
          <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose mb-3">
            تخضع هذه السياسة للأنظمة واللوائح المعمول بها في المملكة العربية السعودية، وأي نزاع
            يتعلق باستخدام المنصّة يتم التعامل معه وفق هذه الأنظمة.
          </p>
          <p className="text-sm sm:text-base text-[#E4F1FF] leading-loose">
            بشكل مبسّط: عبّر عن تجربتك باحترام، لا تكشف معلومات شخصيّة عن أحد، لا تستخدم المنصّة
            للإساءة أو الدعاية، وتذكّر أن كل ما يُنشر هنا هو آراء ناس مثلك، يساعدك تاخذ صورة
            أوضح لكن ما يلغِي مسؤوليتك عن قراراتك الدراسية.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsPage;